export const TOGGLE_ASK_GET_LOCATION = 'TOGGLE_ASK_GET_LOCATION'

export function displayAskGetLocationReducer(state = false, action) {
    switch (action.type){
        case TOGGLE_ASK_GET_LOCATION:
            return action.payload
        default: return state
    }
}